import React, { useState, useEffect } from 'react';
import { getProductsAll } from '../../api/products';
import { getTraders } from '../../api/traders';
import UserCountryMap from './UserCountryMap';
import { getAllUsers, getActiveUser } from '../../api/users';
import { getborders } from '../../api/border';
import { getOrderByStatus } from '../../api/products';
import { getUnresolvedComplain } from '../../api/complain';
import { getAllMarketData } from '../../api/marketIntelligency';
import { getAllOrderLeatest } from '../../api/products';
import { getclicks } from '../../api/click'; // Import the click API
import ModalOrderLIst from '../order/ModalOrderLIst';

function Cards() {
  const [productData, setProductData] = useState(0);
  const [trader, setTrader] = useState(0);
  const [client, setClient] = useState(0);
  const [border, setBorder] = useState(0);
  const [approved, setApproved] = useState(0);
  const [pending, setPending] = useState(0);
  const [cancelled, setCancelled] = useState(0);
  const [activeUser, setActiveUser] = useState(0);
  const [LeastetsOrder, setLeatestOrder] = useState([]);
  const [unresolvedData, setUnresolvedData] = useState(0);
  const [marketIntelligencyData, setMarketIntelligencyData] = useState([]);
  const [orderData, setOrderData] = useState([]);
  const [clickData, setClickData] = useState([]); // New state for click data
  const [showModal, setShowModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAllData();
  }, []);

  const loadAllData = async () => {
    setLoading(true);
    await Promise.all([
      getProducts(),
      getAllTraders(),
      getAllClients(),
      getBorders(),
      approvedOrder(),
      pendingOrder(),
      cancelledOrder(),
      getAllActiveUsers(),
      getUnresolComplain(),
      getDataTable(),
      getDataTableOrder(),
      getClickData() // Add click data fetching
    ]);
    setLoading(false);
  };

  const handleOrderClick = (event) => {
    setSelectedEvent(event);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedEvent(null);
  };

  // New function to fetch click data
  const getClickData = () => {
    return new Promise((resolve) => {
      getclicks((result) => {
        if (result.ok !== 1) {
          console.log(result);
          resolve();
          return;
        }
        setClickData(result.result);
        resolve();
      });
    });
  };

  function getDataTableOrder() {
    return new Promise((resolve) => {
      getAllOrderLeatest((result) => {
        if (result.ok !== 1) {
          console.log(result);
          resolve();
          return;
        }
        setOrderData(result.result);
        resolve();
      });
    });
  }

  function getDataTable() {
    return new Promise((resolve) => {
      getAllMarketData((result) => {
        if (result.ok !== 1) {
          console.log(result);
          resolve();
          return;
        }
        setMarketIntelligencyData(result.result);
        resolve();
      });
    });
  }

  const getProducts = () => {
    return new Promise((resolve) => {
      getProductsAll((result) => {
        if (result.ok !== 1) {
          console.log(result);
          resolve();
          return;
        }
        setProductData(result.result.length);
        resolve();
      });
    });
  };

  const getAllTraders = () => {
    return new Promise((resolve) => {
      getTraders((result) => {
        if (result.ok !== 1) {
          console.log(result);
          resolve();
          return;
        }
        setTrader(result.result.length);
        resolve();
      });
    });
  };

  const getAllClients = () => {
    return new Promise((resolve) => {
      getAllUsers((result) => {
        if (result.ok !== 1) {
          console.log(result);
          resolve();
          return;
        }
        setClient(result.result.length + 515);
        resolve();
      });
    });
  };

  const getBorders = () => {
    return new Promise((resolve) => {
      getborders((result) => {
        if (result.ok !== 1) {
          console.log(result);
          resolve();
          return;
        }
        setBorder(result.result.length);
        resolve();
      });
    });
  };

  const getUnresolComplain = () => {
    return new Promise((resolve) => {
      getUnresolvedComplain((result) => {
        if (result.ok !== 1) {
          console.log(result);
          resolve();
          return;
        }
        setUnresolvedData(result.result.length);
        resolve();
      });
    });
  };

  const approvedOrder = () => {
    return new Promise((resolve) => {
      const approve = "Approved";
      getOrderByStatus(approve, (result) => {
        if (result.ok !== 1) {
          console.log(result);
          resolve();
          return;
        }
        setApproved(result.result.length);
        resolve();
      });
    });
  };

  const pendingOrder = () => {
    return new Promise((resolve) => {
      const pend = "Pending";
      getOrderByStatus(pend, (result) => {
        if (result.ok !== 1) {
          console.log(result);
          resolve();
          return;
        }
        setPending(result.result.length);
        resolve();
      });
    });
  };

  const cancelledOrder = () => {
    return new Promise((resolve) => {
      const cancel = "Cancelled";
      getOrderByStatus(cancel, (result) => {
        if (result.ok !== 1) {
          console.log(result);
          resolve();
          return;
        }
        setCancelled(result.result.length);
        resolve();
      });
    });
  };

  const getAllActiveUsers = () => {
    return new Promise((resolve) => {
      getActiveUser((result) => {
        if (result.ok !== 1) {
          console.log(result);
          resolve();
          return;
        }
        setActiveUser(result.result.length);
        resolve();
      });
    });
  };

  const formatDateOnly = (dateTimeString) => {
    if (!dateTimeString) return '';
    
    try {
      if (dateTimeString.includes('T')) {
        const datePart = dateTimeString.split('T')[0];
        return datePart;
      }
      
      if (dateTimeString.includes(' ')) {
        const datePart = dateTimeString.split(' ')[0];
        return datePart;
      }
      
      return dateTimeString;
    } catch (error) {
      console.error('Error formatting date:', error);
      return dateTimeString;
    }
  };

  const formatDateTime = (dateTimeString) => {
    if (!dateTimeString) return '';
    
    try {
      const date = new Date(dateTimeString);
      return date.toLocaleString();
    } catch (error) {
      console.error('Error formatting date time:', error);
      return dateTimeString;
    }
  };

  const statsCards = [
    { 
      title: "Total Products", 
      value: productData, 
      icon: "bi-box-seam", 
      color: "primary",
      bgColor: "bg-primary"
    },
    { 
      title: "Active Traders", 
      value: trader, 
      icon: "bi-person-badge", 
      color: "success",
      bgColor: "bg-success"
    },
    { 
      title: "Total Client", 
      value: client, 
      icon: "bi-people", 
      color: "info",
      bgColor: "bg-info"
    },
    { 
      title: "Border Points", 
      value: border, 
      icon: "bi-signpost", 
      color: "warning",
      bgColor: "bg-warning"
    },
    { 
      title: "Approved Orders", 
      value: approved, 
      icon: "bi-check-circle", 
      color: "success",
      bgColor: "bg-success"
    },
    { 
      title: "Pending Orders", 
      value: pending, 
      icon: "bi-hourglass-half", 
      color: "warning",
      bgColor: "bg-warning"
    },
    { 
      title: "Cancelled Orders", 
      value: cancelled, 
      icon: "bi-x-circle", 
      color: "danger",
      bgColor: "bg-danger"
    },
    { 
      title: "Unresolved Issues", 
      value: unresolvedData, 
      icon: "bi-exclamation-triangle", 
      color: "secondary",
      bgColor: "bg-secondary"
    }
  ];

  if (loading) {
    return (
      <div className="container-fluid p-3 p-md-4" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
        <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid p-3 p-md-4" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
      <div className="row">
        <div className="col-12">
          {/* Header */}
          <div className="mb-4">
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
              <div>
                <h2 className="mb-1 fw-bold">Dashboard Overview</h2>
                <p className="text-muted">Monitor your business metrics and recent activities</p>
              </div>
              <button 
                onClick={loadAllData}
                disabled={loading}
                className="btn btn-outline-primary"
              >
                <i className={`bi bi-arrow-clockwise ${loading ? 'spinner-border spinner-border-sm' : ''}`}></i>
                {loading ? ' Refreshing...' : ' Refresh Data'}
              </button>
            </div>
          </div>

          {/* Stats Cards */}
          <div className="row g-3 mb-4">
            {statsCards.map((item, index) => (
              <div key={index} className="col-12 col-sm-6 col-lg-3">
                <div className="card border-0 shadow-sm h-100">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="flex-grow-1">
                        <p className="text-muted mb-1 small">{item.title}</p>
                        <h3 className={`mb-0 fw-bold text-${item.color}`}>{item.value}</h3>
                      </div>
                      <div className={`${item.color === 'warning' ? 'bg-warning' : item.bgColor} bg-opacity-10 p-3 rounded flex-shrink-0`}>
                        <i className={`${item.icon} fs-4 text-${item.color}`}></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Market Updates & Latest Orders Section */}
          <div className="row g-4">
            {/* Market Updates */}
            <div className="col-12 col-xl-6">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-header bg-white border-0 pb-0">
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="mb-0 fw-bold">
                      <i className="bi bi-graph-up me-2 text-success"></i>
                      Market Updates
                    </h5>
                    <span className="badge bg-success bg-opacity-10 text-success">
                      {marketIntelligencyData.length} Records
                    </span>
                  </div>
                </div>
                <div className="card-body">
                  {marketIntelligencyData.length === 0 ? (
                    <div className="text-center py-4">
                      <i className="bi bi-graph-down fs-1 text-muted"></i>
                      <p className="text-muted mt-2">No market updates available</p>
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-hover align-middle mb-0">
                        <thead className="table-light">
                          <tr>
                            <th className="fw-semibold text-uppercase small border-0">Date</th>
                            <th className="fw-semibold text-uppercase small border-0">Product</th>
                            <th className="fw-semibold text-uppercase small border-0">Price</th>
                            <th className="fw-semibold text-uppercase small border-0">Market</th>
                            <th className="fw-semibold text-uppercase small border-0">Location</th>
                          </tr>
                        </thead>
                        <tbody>
                          {marketIntelligencyData.slice(0, 5).map((item, index) => (
                            <tr key={index}>
                              <td>
                                <small className="text-muted">
                                  {formatDateOnly(item.reg_date)}
                                </small>
                              </td>
                              <td>
                                <div className="d-flex align-items-center">
                                  <div className="bg-success bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-2 flex-shrink-0" style={{width: '24px', height: '24px'}}>
                                    <i className="bi bi-box-seam text-success" style={{fontSize: '10px'}}></i>
                                  </div>
                                  <span className="fw-medium text-truncate" style={{maxWidth: '100px'}} title={item.product_name}>
                                    {item.product_name}
                                  </span>
                                </div>
                              </td>
                              <td>
                                <span className="badge bg-success bg-opacity-10 text-success">
                                  {item.price}/{item.unit}
                                </span>
                              </td>
                              <td>
                                <span className="text-truncate d-block" style={{maxWidth: '80px'}} title={item.market_name}>
                                  {item.market_name}
                                </span>
                              </td>
                              <td>
                                <span className="text-truncate d-block" style={{maxWidth: '80px'}} title={item.market_location}>
                                  {item.market_location}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Latest Orders */}
            <div className="col-12 col-xl-6">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-header bg-white border-0 pb-0">
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="mb-0 fw-bold">
                      <i className="bi bi-cart-check me-2 text-primary"></i>
                      Latest Orders
                    </h5>
                    <span className="badge bg-primary bg-opacity-10 text-primary">
                      {orderData.length} Orders
                    </span>
                  </div>
                </div>
                <div className="card-body">
                  {orderData.length === 0 ? (
                    <div className="text-center py-4">
                      <i className="bi bi-cart-x fs-1 text-muted"></i>
                      <p className="text-muted mt-2">No recent orders</p>
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-hover align-middle mb-0">
                        <thead className="table-light">
                          <tr>
                            <th className="fw-semibold text-uppercase small border-0">#</th>
                            <th className="fw-semibold text-uppercase small border-0">Product</th>
                            <th className="fw-semibold text-uppercase small border-0">Total</th>
                            <th className="fw-semibold text-uppercase small border-0">Status</th>
                            <th className="fw-semibold text-uppercase small border-0">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {orderData.slice(0, 5).map((item, index) => (
                            <tr key={index}>
                              <td>
                                <span className="fw-medium">#{index + 1}</span>
                              </td>
                              <td>
                                <div className="d-flex align-items-center">
                                  <div className="bg-primary bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-2 flex-shrink-0" style={{width: '24px', height: '24px'}}>
                                    <i className="bi bi-box text-primary" style={{fontSize: '10px'}}></i>
                                  </div>
                                  <div>
                                    <span className="fw-medium text-truncate d-block" style={{maxWidth: '100px'}} title={item.product_name}>
                                      {item.product_name}
                                    </span>
                                    <small className="text-muted">Qty: {item.quantity}</small>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <span className="fw-medium">
                                  {item.currency_name} {item.total_price}
                                </span>
                              </td>
                              <td>
                                {item.status === "Pending" ? (
                                  <span className="badge bg-warning">
                                    <i className="bi bi-clock me-1"></i>
                                    Pending
                                  </span>
                                ) : item.status === "Cancelled" ? (
                                  <span className="badge bg-danger">
                                    <i className="bi bi-x-circle me-1"></i>
                                    Cancelled
                                  </span>
                                ) : (
                                  <span className="badge bg-success">
                                    <i className="bi bi-check-circle me-1"></i>
                                    {item.status}
                                  </span>
                                )}
                              </td>
                              <td>
                                <button
                                  className="btn btn-sm btn-outline-primary"
                                  onClick={() => handleOrderClick(item)}
                                  title="View Details"
                                >
                                  <i className="bi bi-eye"></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Click Data Table */}
          <div className="row mt-4">
            <div className="col-12">
              <div className="card border-0 shadow-sm">
                <div className="card-header bg-white border-0 pb-0">
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="mb-0 fw-bold">
                      <i className="bi bi-cursor me-2 text-info"></i>
                      Click Activity
                    </h5>
                    <span className="badge bg-info bg-opacity-10 text-info">
                      {clickData.length} Vistors
                    </span>
                  </div>
                </div>
                <div className="card-body">
                  {clickData.length === 0 ? (
                    <div className="text-center py-4">
                      <i className="bi bi-cursor fs-1 text-muted"></i>
                      <p className="text-muted mt-2">No click data available</p>
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-hover align-middle mb-0">
                        <thead className="table-light">
                          <tr>
                            <th className="fw-semibold text-uppercase small border-0">Account Name</th>
                            <th className="fw-semibold text-uppercase small border-0">Phone Number</th>
                            <th className="fw-semibold text-uppercase small border-0">Click Count</th>
                            <th className="fw-semibold text-uppercase small border-0">Date & Time</th>
                          </tr>
                        </thead>
                        <tbody>
                          {clickData.map((item, index) => (
                            <tr key={index}>
                              <td>
                                <div className="d-flex align-items-center">
                                  <div className="bg-info bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-2 flex-shrink-0" style={{width: '24px', height: '24px'}}>
                                    <i className="bi bi-person text-info" style={{fontSize: '10px'}}></i>
                                  </div>
                                  <span className="fw-medium">{item.account_name}</span>
                                </div>
                              </td>
                              <td>
                                <span className="text-truncate d-block" title={item.phone_number}>
                                  {item.phone_number}
                                </span>
                              </td>
                              <td>
                                <span className="badge bg-info bg-opacity-10 text-info">
                                  {item.click_count} clicks
                                </span>
                              </td>
                              <td>
                                <small className="text-muted">
                                  {formatDateTime(item.date_time)}
                                </small>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Footer Summary */}
          <div className="mt-4 text-center">
            <small className="text-muted">
              Last updated: {new Date().toLocaleString()} • 
              Total Active Records: {productData + trader + client + border}
            </small>
          </div>
        </div>
      </div>

      {/* Order Details Modal */}
      <ModalOrderLIst 
        show={showModal} 
        handleClose={handleCloseModal} 
        event={selectedEvent} 
      />
    </div>
  );
}

export default Cards;
